export default "__VITE_ASSET__c7dff5e1__"